import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { academyDataActions } from '../../store/academy-slice';
import {
  getListArchivosVideo,
  getStatusLessons,
  getVideoHistory,
  loadLesson
} from 'store/lesson-actions';

import {
  getAccesCourse,
  getCourseAditionalInfo
} from 'store/course-actions';

import NoAccess from './NoAccess/NoAccess';
import LessonLeft from './LessonLeft/LessonLeft';
import LessonRight from './LessonRight/LessonRight';
import Loading from 'components/UI/Loading/Loading';
import BreadCrumbs from 'components/UI/BreadCrumbs/BreadCrumbs';

import classes from './LessonPage.module.css';

const url = window.location.pathname.split('/');

const LessonPage = props => {
  const dispatch = useDispatch();
  const dataAcademy = useSelector(state => state.academyInfo);
  const dataLesson = useSelector(state => state.lessonInfo);
  const dataCourse = useSelector(state => state.courseInfo);
  const [view, setView] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const [actuallyIdLesson, setActuallyIdLesson] = useState(0);
  const [videoProgress, setVideoProgress] = useState(0);
  const [quizProgress, setQuizProgress] = useState(0);
  const [homeworkProgress, setHomeworkProgress] = useState(0);
  const [coevaluationProgress, setCoevaluationProgress] =
    useState(0);

  useEffect(() => {
    dispatch(
      academyDataActions.showBanner({
        showBanner: false
      })
    );
  }, []);

  useEffect(() => {
    if (dataLesson.lessonProgress) {
      dataLesson.lessonProgress.map(item => {
        if (item.eventType === 5) {
          setCoevaluationProgress(item.mediaCoeval);
        }
      });
    }
  }, [dataLesson.lessonProgress]);

  useEffect(() => {
    if (
      dataCourse.accessCourse === null &&
      dataAcademy.data.idAcademy
    ) {
      dispatch(
        getAccesCourse(props.idCourse, dataAcademy.data.idAcademy)
      );
      dispatch(getCourseAditionalInfo(props.idCourse));
    }
  }, [dataCourse.accessCourse, dataAcademy.data]);

  useEffect(() => {
    if (dataCourse.accessCourse) {
      dispatch(
        getVideoHistory(props.idLesson, dataAcademy.data.shortName)
      );
    }
    dispatch(
      loadLesson(
        props.idLesson,
        props.idCourse,
        dataAcademy.data.shortName
      )
    );
    dispatch(getStatusLessons(props.idCourse, props.idLesson));
    dispatch(getListArchivosVideo(props.idLesson, true));
  }, [
    props.idCourse,
    props.idLesson,
    dataAcademy.data,
    dataCourse.accessCourse
  ]);

  useEffect(() => {
    if (
      dataLesson.data.available &&
      dataCourse.accessCourse !== null &&
      dataCourse.data !== null
    ) {
      setActuallyIdLesson(dataLesson.data.idVideo);
    }
  }, [
    dataLesson.lessonProgress,
    dataLesson.data.idVideo,
    dataCourse.accessCourse
  ]);

  useEffect(() => {
    if (props.idLesson == actuallyIdLesson) {
      setIsLoading(false);
    }
  }, [props.idLesson, actuallyIdLesson]);

  const handleChangeVideoStatus = state => {
    setVideoProgress(state);
  };

  const handleChangeQuizStatus = state => {
    setQuizProgress(state);
  };

  const handleChangeHomeworkStatus = state => {
    setHomeworkProgress(state);
  };

  const handleChangeCoevaluationStatus = () => {
    setCoevaluationProgress(coevaluationProgress + 1);
  };

  const changeViewHandler = idView => {
    setView(idView);
  };

  const loadLessonHandler = () => {
    setIsLoading(true);
    setActuallyIdLesson(0);
  };

  return (
    <>
      {!isLoading ? (
        dataCourse.accessCourse ? (
          <section className={classes.lessonPageContainer}>
            {url[2] !== 'course' && (
              <BreadCrumbs
                idCourse={props.idCourse}
                title={dataLesson.data.tituloserie}
                lesson={dataLesson.data.titulo}
              />
            )}
            <aside className={classes.lessonContainer}>
              <LessonLeft
                loadLesson={loadLessonHandler}
                idCourse={props.idCourse}
                idLesson={props.idLesson}
                lessonInfo={dataLesson}
                changeView={changeViewHandler}
                view={view}
                changeVideoStatus={handleChangeVideoStatus}
                changeQuizStatus={handleChangeQuizStatus}
                changeHomeworkStatus={handleChangeHomeworkStatus}
                changeCoevaluationStatus={
                  handleChangeCoevaluationStatus
                }
              />
              <LessonRight
                idCourse={props.idCourse}
                idLesson={props.idLesson}
                lessonInfo={dataLesson}
                changeView={changeViewHandler}
                view={view}
                videoProgress={videoProgress}
                quizProgress={quizProgress}
                homeworkProgress={homeworkProgress}
                coevaluationProgress={coevaluationProgress}
                forumEnabled={dataCourse.aditionalData.forum}
              />
            </aside>
          </section>
        ) : (
          <NoAccess
            idCourse={props.idCourse}
            idEmisor={dataAcademy.data.idAcademy}
            academyName={dataAcademy.data.shortName}
          />
        )
      ) : (
        <Loading />
      )}
    </>
  );
};

LessonPage.propTypes = {
  // eslint-disable-next-line react/require-default-props
  idCourse: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  idLesson: PropTypes.number
};

export default LessonPage;
